export default "__VITE_ASSET__9af07596__"